import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:none;stroke:{{strokeColor}};stroke-width:1.5;stroke-miterlimit:10;}
    .st1{fill:{{strokeColor}};stroke:{{strokeColor}};stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
    .st2{fill:{{strokeColor}};stroke:{{strokeColor}};stroke-width:0.5;stroke-miterlimit:10;}
    .st3{fill:{{strokeColor}};}
  </style>
  <g>
    <path class="st0" d="M11.9,22.4H4.6c-4.9,0-4.2-8.5,0.2-9.3c0,0,1.3-6.5,6.2-3c0,0,2.3-5.7,7.5-4.7c0,0,6.3,0.3,6,7.3
    c0-0.1,2.1,0.9,2.3,1c3.1,1.9,2.9,7.3-0.6,8.7h-7"/>
    <path class="st1" d="M12.6,20c-0.1-0.1-0.1-0.2,0-0.3c0.8-0.7,1.8-1.2,2.9-1.2s2.1,0.4,2.9,1.2c0.1,0.1,0.1,0.2,0,0.3
    c-0.1,0.1-0.2,0.1-0.3,0c-0.7-0.7-1.6-1-2.6-1s-1.9,0.4-2.6,1.1C12.7,20.2,12.6,20.1,12.6,20z"/>
    <path class="st1" d="M10.8,17.9c-0.1-0.1-0.1-0.2,0-0.3c1.3-1.2,3-1.9,4.8-1.9s3.5,0.7,4.8,1.9c0.1,0.1,0.1,0.2,0,0.3
    C20.2,18,20.1,18,20,18c-1.2-1.1-2.8-1.8-4.5-1.8S12.2,16.8,11,18C11,18,10.8,18,10.8,17.9z"/>
    <path class="st2" d="M9.5,15.8c-0.1-0.1-0.1-0.2,0-0.3c1.6-1.6,3.8-2.4,6.1-2.4s4.4,0.9,6,2.4c0.1,0.1,0.1,0.2,0,0.3
    s-0.2,0.1-0.3,0c-1.6-1.5-3.6-2.3-5.8-2.3s-4.2,0.8-5.8,2.3C9.7,15.9,9.5,15.9,9.5,15.8z"/>
    <circle class="st3" cx="15.5" cy="23.2" r="1.5"/>
  </g>
</svg>
`

export const dataSource: ComponentGroup = {
  name: 'dataSource',
  description: 'a group of various data sources',
  icon,
  templates: []
}
